import React, { useContext } from 'react'
import { FormContext } from '../FormContext';
import { Col } from "react-bootstrap";
import "./customelements.css"

const Password = ({ id, label, placeholder, value, example, disabled, mandatory, md }) => {
    const { handleChange } = useContext(FormContext)
    return (
        <Col md={md} className="pad-trl-10">
        <div className="mb-3">
            <label htmlFor="exampleInputEmail1" className="form-label move-left">{mandatory?<span style={{color:"red", marginRight: 5}}>*</span>:""}{label}</label>
            <input type="password" className="form-control move-left custom-input" id="exampleInputEmail1" aria-describedby="emailHelp"
                placeholder={placeholder ? placeholder : 'Password'}
                value={value}
                onChange={event => handleChange(id, event)}
                disabled={disabled}
                autoComplete="new-password"
                required={mandatory}
            />
            {example!==null?<div id="emailHelp" className="text-muted move-left input-example">Example: {example}</div>:<></>}
        </div>
        </Col>
    )
}

export default Password